module.exports = __webpack_public_path__ + "img/cont_like.ceb7a385.svg";